<template>
  <div>
    <div class="custom-menu" :style="{margin:`0 ${config.property_data.margin_num}px`, 'border-radius':`${config.property_data.radius_top}px ${config.property_data.radius_top}px ${config.property_data.radius_bottom}px ${config.property_data.radius_bottom}px`}" @click="jump()">
      <div class="custom-menu-left">
        <img
          v-if="config.property_data.is_icon_show"
          class="custom-menu-left-image"
          :src="
            config.property_data.icon_url ||
            'https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png'
          "
        />
        <div v-else class="custom-menu-left-title">
          {{ config.property_data.name }}
        </div>
      </div>
      <div class="custom-menu-right">
        <div class="custom-menu-right-title">
          {{ config.property_data.sub_title }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-custom-menu",
  props: ["config", "isEditorStatus", "pageData"],

  data() {
    return {};
  },
  computed: {
    app_type () {
      return this.pageData.app_type || 'seller'
    },
  },
  components: {},

  mounted() {},

  methods: {
    jump() {
      if (this.isEditorStatus || !this.config.link_data) {
        return;
      }
      redirectURL(this.config.link_data.toString(), this.app_type);
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>